export default __webpack_public_path__ + "static/media/charles-D-vDQMTfAAU-unsplash.5167f273.png";